import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, InputNumber, Select, Switch, Button, Card } from "antd";
import { handleApiSuccess, handleApiError } from "utils";
import {
  billingTaxRateByIdService,
  billingTaxRateCreateService,
  billingTaxRateUpdateService,
} from "services/billing";
import { US_STATES } from "../constants";

const { Option } = Select;

export default function TaxRateForm({ id }) {
  const history = useHistory();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (id) {
      billingTaxRateByIdService(id)
        .then((response) => {
          if (response.data.item) form.setFieldsValue(response.data.item);
        })
        .catch((error) => handleApiError(error));
    } else {
      form.setFieldsValue({ applies_to: "BOTH", is_active: true });
    }
  }, [id, form]);

  const onFinish = (values) => {
    setIsLoading(true);
    const action = id
      ? billingTaxRateUpdateService(id, values)
      : billingTaxRateCreateService(values);
    action
      .then((response) => {
        setIsLoading(false);
        handleApiSuccess(response);
        history.push("/billing/tax-rates");
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
      });
  };

  return (
    <Card style={{ maxWidth: 560 }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="e.g. Texas Sales Tax" />
        </Form.Item>
        <Form.Item
          label="State"
          name="state"
          rules={[{ required: true, message: "State is required" }]}
        >
          <Select
            showSearch
            placeholder="Select state"
            optionFilterProp="children"
          >
            {US_STATES.map((s) => (
              <Option key={s} value={s}>
                {s}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Rate (%)"
          name="rate_percentage"
          rules={[{ required: true, message: "Rate is required" }]}
        >
          <InputNumber min={0} step={0.01} style={{ width: 160 }} />
        </Form.Item>
        <Form.Item label="Applies To" name="applies_to">
          <Select>
            <Option value="BOTH">All Items</Option>
            <Option value="PHYSICAL_GOOD">Physical Goods Only</Option>
            <Option value="SERVICE">Services Only</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Active" name="is_active" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          {id ? "Update" : "Create"}
        </Button>
      </Form>
    </Card>
  );
}
